import { createInstance } from "@refactorjs/ofetch";
import { defineNuxtPlugin, useRuntimeConfig } from "#imports";
import { options } from "#nuxt-http-options";
import { defu } from "defu";
const httpInstance = (opts) => {
  let instance = createInstance(opts);
  if (options.debug) {
    const log = (level, ...messages) => console[level]("[http]", ...messages);
    instance.onRequest((config) => {
      log("info", "Request:", config);
      return config;
    });
    instance.onRequestError((error) => {
      log("error", "Request error:", error);
    });
    instance.onResponse((res) => {
      log("info", "Response:", res);
      return res;
    });
    instance.onResponseError((error) => {
      log("error", "Response error:", error);
    });
  }
  return instance;
};
export default defineNuxtPlugin((ctx) => {
  const runtimeConfig = useRuntimeConfig();
  const config = import.meta.server ? defu({}, runtimeConfig.http, runtimeConfig.public.http, options) : defu({}, runtimeConfig.public.http, options);
  const baseURL = import.meta.client ? config.browserBaseURL : config.baseURL;
  const defaults = {
    baseURL,
    retry: config.retry,
    timeout: import.meta.server ? config.serverTimeout : config.clientTimeout,
    credentials: config.credentials,
    headers: config.headers
  };
  if (config.proxyHeaders) {
    if (import.meta.server && ctx.ssrContext?.event.node.req.headers) {
      const reqHeaders = { ...ctx.ssrContext.event.node.req.headers };
      for (const h of config.proxyHeadersIgnore) {
        delete reqHeaders[h];
      }
      defaults.headers = { ...reqHeaders, ...defaults.headers };
    }
  }
  const http = httpInstance(defaults);
  if (!globalThis.$http && import.meta.client) {
    globalThis.$http = http;
  }
  return {
    provide: {
      http
    }
  };
});
